export { default } from './AddRecordModalContent';
